const AboutHero = () => {
  return (
    <div className="text-center">
      <h1 className="text-4xl font-extrabold text-gray-900 dark:text-white">
        À propos de nous
      </h1>
      <p className="mt-4 text-lg text-gray-600 dark:text-gray-300">
        Découvrez qui nous sommes et ce que nous faisons.
      </p>
    </div>
  );
};

export default AboutHero;
